/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCommand = createReactComponent("outline", "command", "IconCommand", [["path", { "d": "M7 9a2 2 0 1 1 2 -2v10a2 2 0 1 1 -2 -2h10a2 2 0 1 1 -2 2v-10a2 2 0 1 1 2 2h-10", "key": "svg-0" }]]);

export { IconCommand as default };
//# sourceMappingURL=IconCommand.mjs.map
